import { useRouter } from 'vue-router';
import apiStudio from '~/api/studios';
import HOSTS_WITH_STUDIO_URL_IN_PATH from '~/utils/studio-host';

const isSubdomainsServer = process.env.VUE_APP_IS_SUBDOMAINS_SERVER === 'true';

function isDomainWithStudioInUrl(hostname: string) {
  return HOSTS_WITH_STUDIO_URL_IN_PATH.includes(hostname.toLowerCase());
}

const domainMap = {};
// Hosts the API says have no studio. Without this a crawler on an unmapped domain
// costs one lookup per request (my.namastream.com did ~150 in 3 seconds).
const unknownDomains: Record<string, number> = {};
const UNKNOWN_DOMAIN_TTL_MS = 60 * 1000;

async function resolveStudioUrl(hostname: string, currentRoute: any) {
  if (isDomainWithStudioInUrl(hostname)) {
    return currentRoute.value.params.studio_url as string;
  } else {
    try {
      if (isSubdomainsServer) {
        const studioUrl = hostname.split('.')[0];
        console.log('matched subdomain: ', studioUrl);
        return studioUrl;
      } else {
        if (domainMap[hostname]) {
          console.log('matched cached custom domain: ', domainMap[hostname]);
          return domainMap[hostname];
        }
        if (unknownDomains[hostname] > Date.now()) {
          return undefined;
        }
        const studioUrl = await apiStudio.getStudioUrlForCustomDomain(hostname);
        domainMap[hostname] = studioUrl;
        console.log('matched custom domain: ', studioUrl);
        return studioUrl;
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        unknownDomains[hostname] = Date.now() + UNKNOWN_DOMAIN_TTL_MS;
      }
      return undefined;
    }
  }
}


export default defineNuxtPlugin(async () => {
  const url = useRequestURL();
  const router = useRouter();
  const currentRoute = router.currentRoute;

  // Resolved on the server and sent to the browser in the page payload. Before this the
  // browser repeated the lookup on every load, and if it failed the page ran with undefined.
  const studioURL = useState<string | undefined>('studioURL');
  if (!studioURL.value) {
    studioURL.value = await resolveStudioUrl(url.hostname, currentRoute);
  }
  if (!studioURL.value) {
    console.warn(`studioURL: no studio for host ${url.hostname} (path ${url.pathname})`);
  }

  return {
    provide: {
      studioURL: studioURL.value
    }
  }
})
